import { apiHelper } from './api_helper';

export const EMAIL_ENDPOINT = 'email';
export const emailApi = {
    SelectByCoSo: (dm_coso_id) => apiHelper.get(`${EMAIL_ENDPOINT}/coso/${dm_coso_id}`),
    SelectUsers: (emailId) => apiHelper.get(`${EMAIL_ENDPOINT}/${emailId}/users`),
    SelectById: (emailId) => apiHelper.get(`${EMAIL_ENDPOINT}/${emailId}`),
    SavePheDuyet: (emailId) => apiHelper.post(`${EMAIL_ENDPOINT}/send-email/${emailId}`),
    RejectEmail: (emailId) => apiHelper.post(`${EMAIL_ENDPOINT}/tuchoi-pheduyet`, emailId),
    ApproveEmail: (emailId) => apiHelper.post(`${EMAIL_ENDPOINT}/pheduyet`, emailId),
    SaveAsync: (datasend) => apiHelper.post(`${EMAIL_ENDPOINT}/save-async`, datasend),
    SaveAsyncKetQuaThi: (datasend) => apiHelper.post(`${EMAIL_ENDPOINT}/save-async-ketquathi`, datasend),
    Detail: (id) => apiHelper.get(`${EMAIL_ENDPOINT}/${id}`),
    Insert: (datasend) => apiHelper.post(EMAIL_ENDPOINT, datasend),
    Update: (data) => apiHelper.put(EMAIL_ENDPOINT, data),
    Delete: (id) => apiHelper.delete(`${EMAIL_ENDPOINT}/${id}`),
    Upload: (
        { formFiles,
            ts_email_id
        }) => apiHelper.post(`email/upload/email/${ts_email_id}`, formFiles),
    UploadMauThu: (
        { formFiles,
            ex_mauthu_ketqua_id
        }) => apiHelper.post(`email/upload/ex_mauthu_ketqua/${ex_mauthu_ketqua_id}`, formFiles),
    Import: (data) => apiHelper.put(`${EMAIL_ENDPOINT}/import`, data),
    ValidateImport: (data) => apiHelper.put(`${EMAIL_ENDPOINT}/validate-import`, data),
    ValidateImportEmail: (data) => apiHelper.put(`${EMAIL_ENDPOINT}/validate-import-email`, data),

}